import React from 'react';

import { ItemsDetailsRow, ItemDetails } from './styles';

export default function CustomItemDetailsRow({
  name,
  quantity,
  price,
  disableFormatPrice,
  bold,
  fontFamily,
}) {
  return (
    <ItemsDetailsRow>
      <ItemDetails fontFamily={fontFamily} bold={bold}>
        {name}
      </ItemDetails>
      <ItemDetails fontFamily={fontFamily} bold={bold}>
        {quantity}
      </ItemDetails>
      <ItemDetails fontFamily={fontFamily} bold={bold}>
        {disableFormatPrice ? price : `R\$${price}`}
      </ItemDetails>
    </ItemsDetailsRow>
  );
}
